import {ReportOnfidoVerificationComponent} from "./report.onfido.verification.component";
import {ClientUserOnfidoVerificationComponent} from "./client-user.onfido.verification.component";
import {CheckOnfidoVerificationComponent} from "./check.onfido.verification.component";
import {BreakdownReportOnfidoVerificationComponent} from "./breakdown.report.onfido.verification.component";

export const ONFIDO_VERIFICATION_RESULTS_COMPONENTS = [
    ClientUserOnfidoVerificationComponent,
    ReportOnfidoVerificationComponent,
    CheckOnfidoVerificationComponent,
    BreakdownReportOnfidoVerificationComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/onfido/results/index.ts